export enum MealHistoryStatusEnum {
    OPEN = 'Open',
    CLOSED = 'Closed',
    COMING = 'Coming',
}

export enum MealChoicesEnum {
    SOUP = 'soup',
    TOAST = 'toast',
    HOT_MEAL = 'hot_meal',
}
